/* RESPONSIBLE TEAM: team-ai-insights */
import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';
import { type EditorMode } from 'embercom/components/knowledge-hub/content-editor/drawer-editor';
import { DRAWER_EDITOR_QUERY_PARAMS } from 'embercom/services/knowledge-hub-drawer-editor-service';

export default class OptimizeFinReasonsController extends Controller {
  queryParams = ['suggestionId', 'showApiDocs', 'jobId', ...DRAWER_EDITOR_QUERY_PARAMS];

  // Task suggestion specific query params
  @tracked suggestionId?: string;
  @tracked showApiDocs?: boolean;
  @tracked jobId?: string;

  // Drawer Editor query params
  @tracked activeContentId?: number;
  @tracked activeContentType?: string;
  @tracked editorMode?: EditorMode;
  @tracked collectionId?: string;
  @tracked contentLocale?: string;
  @tracked folderId?: string;
}
